var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrack10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 43,
    viewBox: "0 0 130 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1224 3.45065L58.3554 7.94588C62.0793 8.32433 65.8317 8.33027 69.5568 7.96363L107.733 4.20611C118.054 3.19027 127 11.2988 127 21.6696C127 31.9355 118.226 40.0091 107.996 39.157L68.8198 35.8944C65.583 35.6248 62.3292 35.6292 59.0932 35.9074L30.1308 38.3979C15.5384 39.6528 3 28.1463 3 13.5C3 7.51748 8.17051 2.84579 14.1224 3.45065Z",
    stroke: "currentColor",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack10);
export default __webpack_public_path__ + "static/media/track10.88b986e8.svg";
export { ForwardRef as ReactComponent };